import {PublicationDetailedType, PublicationLightType, sortByActivationDate} from "./cataloguesHelper";

// object type for failed detail requests
type ErrorPromiseType = {
  err: string;
};
// Generic publitas url, to retrieve all online connox publications
const publicationsUrl = "https://api.publitas.com/v1/groups/connox/publications.json";

// check if request is successful by checking if it's not of ErrorPromiseType
const isSuccessfulRequest = (a): a is PublicationDetailedType => {
  return !(a as ErrorPromiseType).err;
};

// request all the informations of the current online catalogues
export const retrieveInformation = async (): Promise<PublicationDetailedType[]> => {
  // First off: get basic infos about all catalogue publications
  const basicInformations = await fetch(publicationsUrl).then(
    (response): Promise<PublicationLightType[]> => response.json(),
  );
  // filter only the ones that are online, and sort them by activation date
  const onlineCatalogues = basicInformations.filter((catalog) => catalog.browserTitle).sort(sortByActivationDate);

  // Second: gather detailed information about every single publication

  // array to collect unresolved promises, allowing also failed requests
  const fetchPromiseArray: Promise<PublicationDetailedType | ErrorPromiseType>[] = [];

  // send request for every single publication
  onlineCatalogues.forEach((onlineCatalogue) => {
    const fetchPromise = fetch(onlineCatalogue.url + ".json")
      .then((resp): Promise<PublicationDetailedType> => resp.json())
      .then((catalogDetails: PublicationDetailedType) => catalogDetails)
      // if error thrown, return non-data object
      .catch((error: Error) => ({err: error.message || "Error"}));

    // Push every request to a promises array
    fetchPromiseArray.push(fetchPromise);
  });

  // wait until every request received its response, and then return result array
  return await Promise.all<PublicationDetailedType | ErrorPromiseType>(fetchPromiseArray).then(
    (publicationDetails: (PublicationDetailedType | ErrorPromiseType)[]) => {
      // when all requests came back, return the array cleaned by the failed requests
      return publicationDetails.filter(isSuccessfulRequest);
    },
  );
};
